import Page from "@/Pages/Page";
import {relativeRoute} from "@/helpers/relativeRoute";
import imageZakelijk from "@images/media/mensenlinq-on-floor.png";
import React from "react";
export default function Zakelijk(){

  return <Page title={'Zakelijk'} harvestId={10594}>


    <section className="hero-image">
      <img src={imageZakelijk}
           alt="Mensenlinq voor de ondernemer"/>
      <div className="container">
        <h1 className="text-center">Mensenlinq voor de ondernemer</h1>
      </div>
    </section>

    <section>
      <div className="container text-left !max-w-screen-sm">
        <h2 className="my-5">Zakelijke partner in de uitvaartbranche</h2>

        <p>Mensenlinq is het platform voor online bekendmaken van een overlijden via <a
          href={relativeRoute('standaard-rouwpagina')}>standaard</a> en <a
          href={relativeRoute('uitgebreide-rouwpagina')}>uitgebreide rouwpagina’s</a>. Naast het bekendmaken
          van een overlijden, dienen deze pagina’s als online condoleanceregister, kan informatie over de uitvaart
          worden toegevoegd en kan de pagina verder gepersonaliseerd worden met foto’s en het levensverhaal van de
          overledene.</p>
        <p>Wist je dat wij ook jouw zakelijke partner in de uitvaartbranche zijn? Ons zakelijke productaanbod is ontworpen met de behoefte van ondernemers die actief zijn in de uitvaart- en rouwbranche in gedachten. Hierdoor kun je als ondernemer in de uitvaartbranche jouw dienstverlening optimaliseren en versterken. Mensenlinq ondersteunt je graag bij het bereiken van jouw doelen. Mensenlinq voor ondernemers biedt twee essentiële tools die jouw bedrijf online zichtbaar maakt: de <a
          href={relativeRoute('adressengids')}>adressengids</a> en het <a
          href={relativeRoute('online-condoleanceregister')}>gratis online condoleanceregister</a>.</p>


        <h2>Online zichtbaarheid verhogen uitvaartbranche</h2>
        <p>Voor nabestaanden is het online condoleanceregister een waardevolle aanvulling op jouw standaard diensten. Dit gratis online condoleanceregister met uitgebreide functionaliteiten kun je in je eigen huisstijl laten ontwerpen en toevoegen aan jouw website. Hierdoor profiteer je gelijk van een breder dienstenaanbod en ben je online beter vindbaar. Bekijk hier meer informatie over het <a
          href={relativeRoute('online-condoleanceregister')}>gratis online condoleanceregister</a> en <a
          href={relativeRoute('online-condoleanceregister-interesse')} target="_blank"> plan een vrijblijvende
          afspraak in</a>!</p>


        <h2>Online gedenkplaats aanbieden</h2>
        <p>Bied jouw klanten eenvoudig een online gedenkplaats waar waardevolle herinneringen, foto’s en het levensverhaal van de overleden dierbare gedeeld kunnen worden. Ook worden op deze pagina de ontvangen condoleances weergegeven, waarmee er op een centrale plek een online herdenkingsplaats ontstaat. Dit product aanbieden aan jouw klanten? <a href={relativeRoute('login')}>Maak een account aan</a>, login, en maak een rouwpagina aan.</p>


        <h2>Advertentieplatform voor uitvaartbranche</h2>
        <p>Met meer dan 600.000 bezoekers per maand is onze website of onze adressengids is dé plek waar jouw bedrijf zich online kan profileren. In de adressengids kun je zichtbaar zijn met bedrijfsnaam, logo, introductietekst, adresgegevens en de URL van jouw eigen website. Dit is een unieke kans om jezelf te presenteren aan een breed publiek en de online zichtbaarheid van jouw bedrijf te vergroten. Potentiële klanten kunnen gemakkelijk contact opnemen, terwijl bestaande klanten snel jouw gegevens kunnen vinden. Meer weten over online adverteren voor de uitvaartbranche? <a href={relativeRoute('advertise')}>Bekijk
          deze pagina</a> en neem vrijblijvend contact met ons op.</p>

        <h2>Online groei en zichtbaarheid van uw rouw- of uitvaartonderneming</h2>
        <p>Bij Mensenlinq begrijpen we dat elke onderneming in de uitvaartbranche uniek is. Daarom hebben we ons zakelijke productaanbod ontwikkeld met flexibiliteit en personalisatie in gedachten. Mensenlinq is er om jou te ondersteunen en jouw bedrijf te laten groeien. Laten we samenwerken om de best mogelijke dienstverlening te bieden aan degenen die dit het meest nodig hebben. Ontdek vandaag nog de voordelen van ons zakelijke productaanbod en verbeter de online vindbaarheid van jouw bedrijf met Mensenlinq.</p>

      </div>
    </section>
  </Page>
}

